<template>
  <div>
    <el-card>
      <p class="Basics">基础资料 <el-button type="primary" @click="fanhui" size="mini"
          style="margin-bottom:10px;margin-left:20px">返回</el-button>
      </p>
      <el-row v-if="detailsData&&detailsData.user">
        <el-col :span="3">
          <div>
            <img :src="detailsData.user.avatar" alt="" style="width: 100px; height: 100px" />
          </div>
          <div>
            <el-button type="primary" @click="edit_data">编辑资料</el-button>
          </div>
        </el-col>
        <el-col :span="7" class="Basics_test">
          <p>用户姓名：{{ detailsData.user.username }}</p>
          <p>
            用户性别：{{
              detailsData.user.sex == null
                ? "-"
                : detailsData.user.sex == 1
                ? "男"
                : detailsData.user.sex == 2
                ? "女"
                : "-"
            }}
          </p>
          <p>
            用户职业：{{
              detailsData.user.job == null ? "-" : detailsData.user.job
            }}
          </p>
          <p>来源方式：微信公众号</p>
          <p>
            备注：{{
              detailsData.user.remark == null ? "-" : detailsData.user.remark
            }}
          </p>
        </el-col>
        <el-col :span="7" class="Basics_test">
          <p>
            手机号：{{
              detailsData.user.phone == null ? "-" : detailsData.user.phone
            }}
          </p>
          <p>
            用户年龄：{{
              detailsData.user.age == null ? "-" : detailsData.user.age
            }}
          </p>
          <p>
            常用收货人：{{
              detailsData.user.consignee == null
                ? "-"
                : detailsData.user.consignee
            }}
          </p>
          <p>注册时间：{{ detailsData.user.create_time }}</p>
          <p>用户类型：{{({1:'普通用户',2:'医生',3:'达人'})[detailsData.user.customer_type] }}</p>
        </el-col>
        <el-col :span="7" class="Basics_test">
          <p>用户ID：{{ detailsData.user.id }}</p>
          <p>
            微信号：{{
              detailsData.user.wechat == null || detailsData.user.wechat == ""
                ? "-"
                : detailsData.user.wechat
            }}
          </p>
          <p>
            详细地址：{{
              detailsData.user.receivingAddress == null
                ? "-"
                : detailsData.user.receivingAddress
            }}
          </p>
          <p>
            最近登陆时间：{{
              detailsData.user.last_login == null
                ? "-"
                : detailsData.user.last_login
            }}
          </p>
        </el-col>
      </el-row>
    </el-card>
    <el-card style="margin-top: 5px">
      <p class="Basics">
        用户标签
        <el-button type="success" size="mini" style="margin-left: 20px" @click="tagsVisble = true">编辑标签</el-button>
      </p>
      <el-tag v-for="(item, index) in dynamicTags1" :key="index">{{
        item.name
      }}</el-tag>
    </el-card>
    <el-card style="margin-top: 5px">
      <p class="Basics">用户资产</p>
      <el-row style="margin-top: 10px" v-if="detailsData&&detailsData.user">
        <el-col :span="6" class="assets">
          <p>累计积分</p>
          <p>{{ detailsData.user.point }}</p>
        </el-col>
        <el-col :span="6" class="assets">
          <p>累计成长值</p>
          <p>{{ detailsData.user.fraction }}</p>
        </el-col>
        <el-col :span="6" class="assets">
          <p>付费会员卡</p>
          <p>无</p>
        </el-col>
        <el-col :span="6" class="assets">
          <p>会员等级</p>
          <p>{{ detailsData.medal.medal_name }}</p>
        </el-col>
      </el-row>
    </el-card>
    <el-card style="margin-top: 5px">
      <p class="Basics">行为统计</p>
      <el-row style="margin-top: 10px" v-if="detailsData">
        <el-col :span="6" class="assets">
          <p>咨询订单数</p>
          <p>{{ detailsData.inquiry }}</p>
        </el-col>
        <el-col :span="6" class="assets">
          <p>商城订单数</p>
          <p>{{ detailsData.order }}</p>
        </el-col>
        <el-col :span="6" class="assets">
          <p>消费金额（元）</p>
          <p>{{ detailsData.consume }}</p>
        </el-col>
        <el-col :span="6" class="assets">
          <p>最近消费时间</p>
          <p>
            {{ detailsData.last_date == null ? "-" : detailsData.last_date }}
          </p>
        </el-col>
      </el-row>
    </el-card>
    <el-card style="margin-top: 5px">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="咨询订单" name="A">
          <el-table :data="tableData" border v-loading="loading" height="400px" ref="configurationTable">
            <el-table-column v-for="(item, ind) in header" :key="ind" :label="item.name" align="center">
              <el-table-column v-show="item.child.length > 0" v-for="iteme in item.child" :key="iteme.key"
                :label="iteme.name" show-overflow-tooltip>
                <template slot-scope="{ row }">
                  <div v-if="iteme.name2">
                    <el-link type="primary" @click="getxx(row)">详情</el-link>
                  </div>
                  <div v-else>{{ row[iteme.key] }}</div>
                </template>
              </el-table-column>
              <template slot-scope="{ row }" v-if="item.child.length < 1">
                {{ row[item.key] }}
              </template>
            </el-table-column>
          </el-table>

          <div class="u-f u-ac u-jsb ft_mr">
            <div></div>
            <el-pagination :current-page="currentPages" :page-sizes="[15, 30, 50, 100]" :page-size="pagesizes"
              layout="total, sizes, prev, pager, next, jumper" :total="counts" @size-change="handleSizeChange1"
              @current-change="handleCurrentChange1">
            </el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane label="商城订单" name="B">
          <el-table border class="mt-3" :data="tableData2" style="width: 100%" @selection-change="handleSelectionChange"
            height="400px">
            <el-table-column type="selection" width="45" align="center">
            </el-table-column>

            <el-table-column label="商品" width="600">
              <template slot-scope="scope">
                <div class="d-flex">
                  <div style="flex: 1">
                    <p class="mb-1">订单编号：</p>
                    <p class="mb-1">
                      <small>{{ scope.row.no }}</small>
                    </p>
                  </div>
                  <div style="flex: 1">
                    <p class="mb-1">下单时间：</p>
                    <p class="mb-1">
                      <small>{{ scope.row.create_time }}</small>
                    </p>
                  </div>
                </div>
                <div class="media border-top py-2" v-for="(item, index) in scope.row.order_items" :key="index">
                  <div v-if="item.goods_item" class="pic_b">
                    <div class="u-f u-ac u-jsb">
                      <div class="u-f u-ac">
                        <img class="mr-3" style="width: 60px; height: 60px" v-if="item.goods_item.cover"
                          :src="item.goods_item.cover[0].url" />
                        <span class="goods_gg">{{ item.skusTextArr }} ×{{ item.num }}</span>
                      </div>
                      <div class="is_tk" v-if="scope.row.closed != 1">
                        <div v-if="item.refund_status != 'pending'">
                          {{ item.refund_status_text }}
                        </div>
                        <div v-if="
                            item.refund_status == 'pending' &&
                            scope.row.paid_time
                          " class="color_red">
                          {{ item.ship_status_text }}
                        </div>
                        <div v-else-if="
                            item.refund_status == 'pending' &&
                            !scope.row.paid_time
                          " class="color_red">
                          未付款
                        </div>

                        <el-button type="danger" @click="tk_clisk(scope.row, item)"
                          v-if="item.refund_status == 'applied'" size="mini" round>退款处理</el-button>
                        <span v-if="item.refund_status == 'agree'" style="color: red">已同意退款</span>
                        <el-button type="danger" @click="qr_tk_clisk(scope.row, item)"
                          v-if="item.refund_status == 'wait'" size="mini" round>确认收货并退款</el-button>
                        <el-button @click="tk_jh_wl(scope.row, item)" v-if="item.refund_status == 'wait'" size="mini"
                          round>退款寄回物流</el-button>

                        <el-button type="text" size="mini" @click="ship(item)" v-if="
                            scope.row.paid_time &&
                            item.ship_status === 'pending' &&
                            (item.refund_type == 0 || !item.refund_type)
                          ">
                          订单发货</el-button>
                        <el-button type="text" size="mini" v-if="
                            item.ship_status === 'delivered' &&
                            scope.row.closed === 0 &&
                            scope.row.payment_method &&
                            item.refund_status === 'pending' &&
                            (item.refund_type == 0 || !item.refund_type)
                          " @click="wlDetail(item)">物流信息</el-button>
                      </div>
                    </div>
                    <div class="media-body">
                      <div class="mt-0">
                        <a class="text-primary">{{ item.goods_item.title }}</a>
                      </div>
                    </div>
                    <div class="shjlbtn_b">
                      <div class="sh_jl" @click="getshjl(item)">售后记录</div>
                    </div>
                  </div>
                  <span class="text-muted" v-else>该商品已被删除</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" width="120" label="实付款">
              <template slot-scope="scope">
                <span>￥{{ scope.row.total_price }}</span>
                <p><small>(含运费：￥0.00)</small></p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="买家">
              <template slot-scope="scope">
                <div class="tx_pic" :style="'background:url(' + scope.row.user_avatar + ')'"></div>
                <!-- <el-avatar shape="square" :size="100" fit="contain"  :src="scope.row.user_avatar"></el-avatar> -->
                <span>{{ scope.row.user_name }}</span>
                <p>
                  <small>(用户id：{{ scope.row.user_id }})</small>
                </p>
              </template>
            </el-table-column>
            <el-table-column prop="status" align="center" label="支付方式" width="150">
              <template slot-scope="scope">
                <span class="badge badge-success" v-if="scope.row.payment_method === 'wechat'">微信支付</span>
                <span class="badge badge-primary" v-else-if="scope.row.payment_method === 'alipay'">支付宝支付</span>
                <span class="badge badge-secondary" v-else>未支付</span>
              </template>
            </el-table-column>
            <el-table-column align="center" width="170" label="交易状态">
              <template slot-scope="scope">
                <div>
                  付款状态:
                  <span class="badge" :class="
                      scope.row.payment_method
                        ? 'badge-success'
                        : 'badge-secondary'
                    ">{{ scope.row.payment_method ? "已付款" : "未付款" }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" width="170" label="订单状态">
              <template slot-scope="scope">
                <div>
                  <span class="badge" :class="
                      scope.row.closed == 0
                        ? 'badge-success'
                        : 'badge-secondary'
                    ">{{ { 0: "正常", 1: "已关闭" }[scope.row.closed] }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="150">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="orderDetail(scope.row)">订单详情</el-button>
                <!-- <el-button type="text" size="mini"
						v-if="scope.row.ship_status ==='delivered' && scope.row.closed === 0 && scope.row.payment_method && scope.row.refund_status === 'pending'"
						@click="wlDetail(scope.row)">物流信息</el-button> -->
                <!-- <el-button type="text" size="mini" @click="ship(scope.row)"
						v-if="scope.row.ship_status ==='pending' && scope.row.closed === 0 && scope.row.payment_method && scope.row.refund_status === 'pending'">
						订单发货</el-button> -->
              </template>
            </el-table-column>
          </el-table>

          <div class="u-f u-ac u-jsb ft_mr">
            <div></div>
            <el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size"
              layout="total, sizes, prev, pager, next, jumper" :total="page.total" @size-change="handleSizeChange"
              @current-change="handleCurrentChange">
            </el-pagination>
          </div>

        </el-tab-pane>
        <el-tab-pane label="积分记录" name="C">
          <el-table :data="tableData3" style="width: 100%" height="400px">
            <el-table-column prop="create_time" label="操作时间" width="180">
            </el-table-column>
            <el-table-column prop="beforPoint" label="操作前数值" width="180">
            </el-table-column>
            <el-table-column prop="kcurrency" label="积分数值">
            </el-table-column>
            <el-table-column prop="endPoint" label="操作后数值"> </el-table-column>
            <el-table-column prop="rule.name" label="积分原因">
            </el-table-column>
            <el-table-column prop="name" label="备注"> </el-table-column>
          </el-table>

          <div class="u-f u-ac u-jsb ft_mr">
            <div></div>
            <el-pagination :current-page="page3.current" :page-sizes="page3.sizes" :page-size="page3.size"
              layout="total, sizes, prev, pager, next, jumper" :total="page3.total" @size-change="handleSizeChange3"
              @current-change="handleCurrentChange3">
            </el-pagination>
          </div>

        </el-tab-pane>
        <el-tab-pane label="成长值记录" name="D">
          <el-table :data="tableData4" style="width: 100%" height="400px">
            <el-table-column prop="create_time" label="操作时间" width="180">
            </el-table-column>
            <el-table-column prop="beforPoint" label="操作前成长值" width="180">
            </el-table-column>
            <el-table-column prop="kcurrency" label="成长值数值">
            </el-table-column>
            <el-table-column prop="endPoint" label="操作后成长值">
            </el-table-column>
            <el-table-column prop="rule.name" label="成长值原因">
            </el-table-column>
            <el-table-column prop="name" label="备注"> </el-table-column>
          </el-table>

          <div class="u-f u-ac u-jsb ft_mr">
            <div></div>
            <el-pagination :current-page="page4.current" :page-sizes="page4.sizes" :page-size="page4.size"
              layout="total, sizes, prev, pager, next, jumper" :total="page4.total" @size-change="handleSizeChange4"
              @current-change="handleCurrentChange4">
            </el-pagination>
          </div>

        </el-tab-pane>
        <el-tab-pane label="优惠券" name="E">
          <el-table :data="tableData5" style="width: 100%" height="400px">
            <el-table-column prop="create_time" label="获得时间" width="180">
            </el-table-column>
            <el-table-column prop="source" label="获得途径" width="180">
            </el-table-column>
            <el-table-column prop="coupon.name" label="优惠卷名称">
            </el-table-column>
            <el-table-column prop="coupon.remork" label="优惠明细">
            </el-table-column>
            <el-table-column label="使用期限" width="340px">
              <template slot-scope="scope">
                {{
                  scope.row.start_time == 0
                    ? "无期限"
                    : scope.row.start_time + "至" + scope.row.end_time
                }}
              </template>
            </el-table-column>
            <el-table-column prop="used" label="使用状态">
              <template slot-scope="scope">
                {{ scope.row.used == 0 ? "未使用" : "已使用" }}
              </template>
            </el-table-column>
            <el-table-column prop="update_time" label="使用时间">
              <template slot-scope="{row}">
                <span v-if="row.used==1">{{row.update_time}}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-card>
    <el-dialog title="编辑基础资料" :visible.sync="dialogFormVisible" width="40%" top="10vh">
      <el-form :model="forms" inline :label-position="labelPosition">
        <el-form-item label="用户姓名" :label-width="formLabelWidth">
          <el-input v-model="forms.name" autocomplete="off" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="联系方式" :label-width="formLabelWidth">
          <el-input v-model="forms.phone" autocomplete="off" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="用户性别" :label-width="formLabelWidth">
          <el-radio-group v-model="forms.radio" style="width: 300px">
            <el-radio :label="1">男</el-radio>
            <el-radio :label="2">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="用户年龄" :label-width="formLabelWidth">
          <el-input v-model="forms.age" autocomplete="off" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="微信号" :label-width="formLabelWidth">
          <el-input v-model="forms.weixin" autocomplete="off" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="用户职业" :label-width="formLabelWidth">
          <el-input v-model="forms.occupation" autocomplete="off" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="常用收货人" :label-width="formLabelWidth">
          <el-input v-model="forms.receiving" autocomplete="off" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="详细地址" :label-width="formLabelWidth">
          <el-input v-model="forms.address" autocomplete="off" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="用户备注" :label-width="formLabelWidth">
          <el-input v-model="forms.remarks" autocomplete="off" style="width: 300px"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="uploadDetails">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="聊天记录" :visible.sync="dialogVisible" class="dialogs" center width="40%">
      <el-divider></el-divider>
      <div class="dialog-ibox-content">
        <div style="max-width: 500px; overflow: auto">
          <div v-for="(item, index) in list" :key="index" class="rec_wp">
            <div class="u-f">
              <div>
                <img :src="item.avatar" alt="" width="50" height="50" class="imgs" />
              </div>
              <div>
                <div>{{ item.create_time }}</div>
                <div>{{ item.send_context }}</div>
              </div>
            </div>
          </div>
        </div>
        <div style="margin-top: 10px" class="u-f u-ac u-jsb">
          <div></div>
          <el-pagination background layout="prev, pager, next" :total="count" small :page-size="pagesize"
            :current-page="page2" @current-change="handleCurrentChange2"></el-pagination>
        </div>
      </div>
      <el-divider></el-divider>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="订单详情" :visible.sync="orderdetaildialog" top="20px" width="50%" @close="closeorderDetailwl">
      <el-form :model="orderForm" ref="ruleForm" label-width="100px" v-loading="orderLoading">
        <el-form-item label="商品:">
          <div class="u-f u-wrap">
            <div v-for="(good, index) in orderForm.orderItems" :key="index" class="items">
              <div class="items_inner">
                <img v-if="good.goodsItem" :src="good.goodsItem.cover[0].url" alt="" />
                <el-tooltip class="" v-if="good.goodsItem" effect="dark" :content="good.goodsItem.title"
                  placement="bottom">
                  <div class="g_tit">{{ good.goodsItem.title }}</div>
                </el-tooltip>
                <el-tooltip class="item" v-if="good.skusText" effect="dark" :content="good.skusText" placement="bottom">
                  <div class="gg">规格:{{ good.skusText }}</div>
                </el-tooltip>

                <div class="g_price">￥{{ good.price }}×{{ good.num }}</div>
                <div v-if="good.ship_data" class="kd">
                  {{ good.ship_data.express_company }}
                </div>
                <div v-if="good.ship_data" class="kd">
                  {{ good.ship_data.express_no }}
                </div>
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="总价:">
          <div>￥{{ orderForm.total_price }}</div>
        </el-form-item>
        <el-form-item label="收货信息:" v-if="orderForm.address">
          <span class="shxx">{{ orderForm.address.name }}</span>
          <span class="shxx">{{ orderForm.address.phone }}</span>
          <span class="shxx">{{ orderForm.address.province }}/{{ orderForm.address.city }}/{{
              orderForm.address.district
            }}{{ orderForm.address.address }}</span>
        </el-form-item>
        <el-form-item label="订单号:">
          <div>
            {{ orderForm.no }}
          </div>
        </el-form-item>
        <el-form-item label="订单状态:">
          <div :class="orderForm.closed == 0 ? 'o_state' : 'o_state2'">
            {{ { 0: "正常", 1: "关闭" }[orderForm.closed] }}
          </div>
        </el-form-item>
        <el-form-item label="支付信息:">
          <span class="shxx">支付金额：<span
              :class="orderForm.closed == 0 ? 'o_state' : 'o_state2'">￥{{ orderForm.pay_amount }}</span>
          </span>
          <span class="shxx">支付时间：<span :class="orderForm.closed == 0 ? 'o_state' : 'o_state2'">{{
                orderForm.paid_time
                  ? date("Y-m-d H:i:s", orderForm.paid_time)
                  : "未支付"
              }}</span></span>
          <span class="shxx">支付积分：<span
              :class="orderForm.closed == 0 ? 'o_state' : 'o_state2'">{{ orderForm.pay_kcurrency }}</span></span>
          <span class="shxx">支付类型：<span
              :class="orderForm.closed == 0 ? 'o_state' : 'o_state2'">{{ orderForm.payment_method }}</span></span>
        </el-form-item>
        <el-form-item label="使用优惠券:">
          <div v-if="orderForm.couponUserItem">
            {{
              orderForm.couponUserItem.coupon
                ? orderForm.couponUserItem.coupon.name
                : "未使用优惠券"
            }}
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="orderdetaildialog = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="订单发货" :visible.sync="shipModal" width="30%">
      <el-form :model="shipForm" ref="ruleForm">
        <el-form-item label="快递公司" prop="express_company">
          <el-select v-model="shipForm.express_company" placeholder="请选择">
            <el-option v-for="(item, index) in express_company_options" :key="index" :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="快递单号" prop="express_no">
          <el-input type="text" v-model="shipForm.express_no"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="shipModal = false">取 消</el-button>
        <el-button type="primary" @click="shipSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="售后记录" :visible.sync="sh_dialog" width="40%" top="80px">
      <div class="wl_box" v-loading="shloading">
        <el-timeline>
          <el-timeline-item v-for="(activity, index) in shlists" :key="index" :timestamp="activity.create_time">
            {{ activity.op_user }}：
            <div v-for="(r, index) in activity.refund_details" :key="index">
              {{ r }}
            </div>
          </el-timeline-item>
        </el-timeline>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="sh_dialog = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="物流信息" :visible.sync="wldetaildialog" top="20px" width="50%" @close="closeorderDetail">
      <div class="top_kk_b u-f u-ac">
        <div class="kk1">
          <img :src="wldata.logo" alt="" />
        </div>
        <div class="kk2">
          <div class="kk_name">{{ wldata.typename }}</div>
          <div class="kk_num">{{ wldata.number }}</div>
        </div>
      </div>
      <div class="wl_box" v-loading="wlloading">
        <el-timeline>
          <el-timeline-item v-for="(activity, index) in allwldetail" :key="index" :timestamp="activity.time"
            :color="index == 0 ? '#0bbd87' : ''">
            {{ activity.status }}
          </el-timeline-item>
        </el-timeline>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="wldetaildialog = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="编辑标签" :visible.sync="tagsVisble" width="40%" top="10vh">
      <el-select v-model="dynamicTags22" multiple collapse-tags style="margin-left: 20px" placeholder="请选择"
        :multiple-limit="3">
        <el-option v-for="item in dynamicTags" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
      <div slot="footer" class="dialog-footer">
        <el-button @click="tagsVisble = false">取 消</el-button>
        <el-button type="primary" @click="uploadtags">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import common from "@/common/mixins/common.js";
  export default {
    mixins: [common],
    inject: ["layout"],
    data() {
      return {
        preUrl: "order",
        //选项卡
        activeName: "B",
        //表单排列格式
        labelPosition: "top",
        //积分记录
        tableData3: [],
        //成长值记录
        tableData4: [],
        //优惠卷
        tableData5: [],
        //基础资料弹框
        dialogFormVisible: false,
        //编辑资料弹窗
        forms: {
          radio: "",
          name: "",
          phone: "",
          age: "",
          weixin: "",
          occupation: "",
          receiving: "",
          address: "",
          remarks: "",
        },
        formLabelWidth: "120px",
        //咨询订单
        loading: false,
        tableData: [],
        header: [],
        zxsource_value: "",
        zxtype_value: "",
        zxstatus_value: "",
        formData: {
          time: [],
        },
        pagesizes: 10,
        pagesize: 10,
        currentPages: 1,
        objxx: "",
        page2: 1,
        list: [],
        count: 0,
        dialogVisible: false,
        //商城订单
        tableData2: [],
        tabIndex: 0,
        tabbars: [{
            name: "全部",
            key: "all",
          },
          {
            name: "待付款",
            key: "nopay",
          },
          {
            name: "待发货",
            key: "noship",
          },
          {
            name: "已发货",
            key: "shiped",
          },
          {
            name: "已收货",
            key: "received",
          },
          {
            name: "已完成",
            key: "finish",
          },
          {
            name: "已关闭",
            key: "closed",
          },
          {
            name: "退款中",
            key: "refunding",
          },
        ],
        form: {
          no: "",
          time: "",
          name: "",
          phone: "",
        },
        orderdetaildialog: false,
        orderForm: {},
        date: xaoi.date,
        allwldetail: "",
        orderLoading: false,
        sh_dialog: false,
        shloading: false,
        shipModal: false,
        shipForm: {
          express_company: "",
          express_no: "",
        },
        shipId: 0,
        express_company_options: [],
        shlists: [],
        wldetaildialog: false,
        wlloading: false,
        wldata: "",
        row: "",
        counts: 0,
        //积分
        page3: {
          current: 1,
          sizes: [10, 20, 50, 100],
          size: 10,
          total: 0,
        },
        //成长值
        page4: {
          current: 1,
          sizes: [10, 20, 50, 100],
          size: 10,
          total: 0,
        },
        detailsData: null,
        //修改标签
        dynamicTags: ["标签一", "标签二", "标签三"],
        inputVisible: false,
        inputValue: "",
        tagsVisble: false,
        dynamicTags22: [],
        dynamicTags1: []
      };
    },

   async created() {
      this.row =await JSON.parse(this.$route.query.rows);
      this.getdetails();
      this.searchTags();
      this.axios
        .get("/admin/express_company/1?limit=50", {
          token: true,
        })
        .then((res) => {
          let data = res.data.data;
          this.express_company_options = data.list;
        });
    },
    computed: {
      tab() {
        return this.tabbars[this.tabIndex].key;
      },
      params() {
        let str = "";
        for (let key in this.form) {
          let val = this.form[key];
          if (val) {
            if (Array.isArray(val)) {
              str += `&starttime=${val[0]}`;
              str += `&endtime=${val[1]}`;
            } else {
              str += `&${key}=${this.form[key]}`;
            }
          }
        }
        return str;
      },
    },
    methods: {
      handleClick(tab, event) {
        if (tab.label == "咨询订单") {
          this.search();
        } else if (tab.label == "积分记录") {
          this.getjifen();
        } else if (tab.label == "成长值记录") {
          this.getchengzhang();
        } else if (tab.label == "优惠券") {
          this.getyouhui();
        }
      },
      getxx(row) {
        this.dialogVisible = true;
        this.objxx = row;
        this.page2 = 1;
        this.getMessage();
      },
      getMessage() {
        axios
          .post(
            "/admin/pc/KkysDoctorInquiryLogs/logsRecord", {
              page: this.page2,
              page_count: this.pagesize,
              inquiry_id: this.objxx.id,
            }, {
              token: true,
            }
          )
          .then((response) => {
            this.list = response.data.data.list;
            this.count = response.data.data.totalCount;
          })
          .catch((error) => {});
      },
      handleCurrentChange2(val) {
        this.page2 = val;
        this.getMessage();
      },
      //商城订单
      getListResult(e) {
        this.tableData2 = e.list;
      },
      orderDetail(row) {
        this.orderLoading = true;
        this.axios
          .get(`/admin/pc/order/${row.id}`, {
            token: true,
          })
          .then((res) => {
            this.orderForm = res.data.data;
            this.orderLoading = false;
          });
        this.orderdetaildialog = true;
      },
      closeorderDetail() {
        this.orderForm = {};
      },
      closeorderDetailwl() {
        this.allwldetail = "";
      },
      wlDetail(row) {
        this.wldetaildialog = true;
        this.wlloading = true;
        this.axios
          .get(`/admin/pc/orderItem/get_ship_info?id=${row.id}`, {
            token: true,
          })
          .then((res) => {
            this.wlloading = false;
            if (res.data.code == 200) {
              this.allwldetail = res.data.data.result.list;
              this.wldata = res.data.data.result;
            } else {
              this.wldetaildialog = false;
              this.$message.error(res.data.msg);
            }
          });
      },
      tk_jh_wl(row, item) {
        this.wldetaildialog = true;
        this.wlloading = true;
        this.axios
          .get(`/admin/pc/orderItem/get_ship_info?id=${item.id}`, {
            token: true,
          })
          .then((res) => {
            this.wlloading = false;
            if (res.data.code == 200) {
              this.allwldetail = res.data.data.result.list;
              this.wldata = res.data.data.result;
            } else {
              this.wldetaildialog = false;
              this.$message.error(res.data.msg);
            }
          });
      },
      async getshjl(item) {
        this.shloading = true;
        this.sh_dialog = true;
        let res = await this.ajax("orderItem/RefundHistory", {
          order_item_id: item.id,
        });
        this.shlists = res.data.list;
        this.shloading = false;
      },
      ship(item) {
        this.shipId = item.id;
        this.shipModal = true;
      },
      shipSubmit() {
        this.layout.showLoading();
        this.axios
          .post(
            "/admin/orderItem/orderItemsShip", {
              ...this.shipForm,
              id: this.shipId,
            }, {
              token: true,
            }
          )
          .then((res) => {
            this.shipModal = false;
            this.$message({
              type: "success",
              message: "发货成功",
            });
            this.getList();
            this.layout.hideLoading();
          })
          .catch((err) => {
            this.layout.hideLoading();
          });
      },
      // 获取请求列表分页url
      getListUrl() {
        return `/admin/${this.preUrl}/${this.page.current}?limit=${this.page.size}&tab=${this.tab}${this.params}&user_id=${JSON.parse(this.$route.query.rows).id}`;
      },
      //咨询订单
      search() {
        let that = this;
        that.loading = true;

        axios
          .post(
            "/admin/Report/getZxmxTable", {
              page: that.currentPages,
              page_count: that.pagesizes,
              date1: this.formData.time ? this.formData.time[0] : "",
              date2: this.formData.time ? this.formData.time[1] : "",
              inquiry_type: this.zxtype_value,
              order_status: this.zxstatus_value,
              order_source: this.zxsource_value,
              user_id: this.row.id,
            }, {
              token: true,
            }
          )
          .then((response) => {
            that.loading = false;
            that.tableData = response.data.list;
            that.header = response.data.header;
            that.counts = response.data.count;
          })
          .catch((error) => {});
      },
      //积分
      getjifen() {
        this.axios
          .post(
            "/admin/userInfo/getUserPoint", {
              user_id: this.row.id, //4537
              page: this.page3.current,
              limit: this.page3.size,
            }, {
              token: true,
            }
          )
          .then((response) => {
            this.loading = false;
            this.tableData3 = response.data.data.point;
            this.page3.total = response.data.data.point_coount;
          })
          .catch((error) => {});
      },
      //成长值
      getchengzhang() {
        this.axios
          .post(
            "/admin/userInfo/getUserPoint", {
              user_id: this.row.id, //4537
              page: this.page4.current,
              limit: this.page4.size,
            }, {
              token: true,
            }
          )
          .then((response) => {
            this.loading = false;
            this.tableData4 = response.data.data.grow;
            this.page4.total = response.data.data.grow_count;
          })
          .catch((error) => {});
      },
      //优惠券
      getyouhui() {
        this.axios
          .post(
            "/admin/userInfo/getCouponUserList", {
              user_id: this.row.id, //4537
            }, {
              token: true,
            }
          )
          .then((response) => {
            this.loading = false;
            this.tableData5 = response.data.data;
          })
          .catch((error) => {});
      },
      //获取基础资料数据
      getdetails() {
        this.axios
          .post(
            "/admin/userInfo/findUserBaseInfo", {
              user_id: this.row.id, //a.id  4537
            }, {
              token: true,
            }
          )
          .then((response) => {
            this.loading = false;
            this.detailsData = response.data.data;
            this.dynamicTags1 = response.data.data.label
          })
          .catch((error) => {});
      },
      //分页咨询订单
      handleSizeChange1(val) {
        this.pagesizes = val;
        this.search();
      },
      handleCurrentChange1(val) {
        this.currentPages = val;
        this.search();
      },
      //分页积分
      handleSizeChange3(val) {
        this.page3.size = val;
        this.getjifen();
      },
      handleCurrentChange3(val) {
        this.page3.current = val;
        this.getjifen();
      },
      //分页成长值
      handleSizeChange4(val) {
        this.page4.size = val;
        this.getchengzhang();
      },
      handleCurrentChange4(val) {
        this.page4.current = val;
        this.getchengzhang();
      },
      //编辑资料按钮
      edit_data() {
        this.dialogFormVisible = true;
        this.forms = {
          radio: this.detailsData.user.sex,
          name: this.detailsData.user.username,
          phone: this.detailsData.user.phone,
          age: this.detailsData.user.age,
          weixin: this.detailsData.user.wechat,
          occupation: this.detailsData.user.job,
          receiving: this.detailsData.user.consignee,
          address: this.detailsData.user.receivingAddress,
          remarks: this.detailsData.user.remark,
        };
      },
      uploadDetails() {
        this.dialogFormVisible = false;
        this.axios
          .post(
            "/admin/userInfo/editUserInfo", {
              user_id: this.row.id, //4537
              sex: this.forms.radio,
              username: this.forms.name,
              phone: this.forms.phone,
              age: this.forms.age,
              wechat: this.forms.weixin,
              job: this.forms.occupation,
              consignee: this.forms.receiving,
              address: this.forms.address,
              remark: this.forms.remarks,
            }, {
              token: true,
            }
          )
          .then((response) => {
            this.getdetails();
          })
          .catch((error) => {});
      },
      //修改标签
      handleClose(tag) {
        this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      },

      showInput() {
        this.inputVisible = true;
        this.$nextTick((_) => {
          this.$refs.saveTagInput.$refs.input.focus();
        });
      },

      handleInputConfirm() {
        let inputValue = this.inputValue;
        if (inputValue) {
          this.dynamicTags.push(inputValue);
        }
        this.inputVisible = false;
        this.inputValue = "";
      },
      uploadtags() {
        this.axios
          .post(
            "/admin/userInfo/editUserLabel", {
              user_id: this.row.id,
              label_id: this.dynamicTags22,
            }, {
              token: true,
            }
          )
          .then((res) => {
            if (res.data.code == 200) {
              this.tagsVisble = false
              this.getdetails()
              this.$message.success("操作成功");
            } else {
              this.$message.error(res.data.msg);
            }
          });
      },
      searchTags() {
        let that = this;
        axios
          .get(`/admin/user_label/1?limit=100`, {
            token: true,
          })
          .then((res) => {
            that.dynamicTags = res.data.data.list;
          })
          .catch((error) => {});
      },
      fanhui() {
        this.$router.go(-1)
      }
    },
  };
</script>

<style scoped lang="scss">
  .Basics {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .Basics_test p {
    margin-bottom: 10px;
    font-size: 16px;
  }

  .assets p:first-child {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 30px;
  }

  .assets p {
    text-align: center;
  }

  .shjlbtn_b {
    display: flex;
    justify-content: flex-end;

    .sh_jl {
      border: 1px solid #666;
      color: #666;
      border-radius: 20px;
      padding: 0px 4px;
      font-size: 12px;
      cursor: pointer;
    }
  }

  .color_red {
    color: red;
  }

  .pic_b {
    width: 100%;

    .goods_gg {
      font-size: 12px;
    }

    .is_tk {
      display: flex;
      align-items: flex-end;
      flex-direction: column;
    }
  }

  .el-tag+.el-tag {
    margin-left: 10px;
  }

  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }

  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
</style>